import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { coversApi, Cover } from "../api";
import type { PlatePreset } from "../components/BookCover/BookCover";

interface CoverState {
  value: Cover | null;
  loading: boolean;
}

const initialState: CoverState = {
  value: null,
  loading: true,
};

export const fetchCover = createAsyncThunk(
  "cover/fetch",
  async (templateId: number) => {
    const { data } = await coversApi.get(templateId);
    return data;
  }
);

export const saveCover = createAsyncThunk(
  "cover/save",
  async (payload: {
    templateId: number;
    authorName: string;
    receiverName?: string;
    bookTitle: string;
    coverUrl?: string;
    platePreset?: PlatePreset;
  }) => {
    const { data } = await coversApi.upsert(payload);
    return data;
  }
);

export const coverSlice = createSlice({
  name: "cover",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCover.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCover.fulfilled, (state, action) => {
        state.value = action.payload;
        state.loading = false;
      })
      .addCase(fetchCover.rejected, (state) => {
        state.value = null;
        state.loading = false;
      })
      .addCase(saveCover.fulfilled, (state, action) => {
        state.value = action.payload;
      });
  },
});
